import React from "react"

import Page from "../components/Page"

const Page404 = () => <Page title="Not found">NOT FOUND</Page>

export default Page404
